import {Validators} from '@angular/forms';

import {LatinDigitsValidator, OnlyDigitsValidator, WhitespaceValidator} from '@spa/validators';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, DatepickerControl, SelectControl} from '../../../app/shared/classes';

export const IdentityDetailsFormArraySelector = 'identityDetails';

export const IdentityDetailIdSelector = 'id';
export const IdentityDocumentTypeSelector = 'documentType';
export const IdentityDocumentNumberSelector = 'documentNumber';
export const IdentityDocumentExpirationDateSelector = 'expirationDate';
export const IdentityDocumentStatusSelector = 'documentStatus';
export const IdentityDocumentPoISelector = 'documentProofOfIdentity';

export const IdentityDocumentNumberMaxLength = 30;

export const IdentityDetailControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: IdentityDetailIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            hidden: true
        }),
        new SelectControl({
            name: IdentityDocumentTypeSelector,
            value: '',
            placeholder: 'Document type',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new BaseControl({
            name: IdentityDocumentNumberSelector,
            value: '',
            placeholder: 'Document number',
            validators: [WhitespaceValidator(), LatinDigitsValidator(), Validators.maxLength(IdentityDocumentNumberMaxLength)],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true,
        }),
        new DatepickerControl({
            name: IdentityDocumentExpirationDateSelector,
            value: '',
            placeholder: 'Expiration date',
            validators: [],
            componentType: ComponentTypesEnum.LockableDatepicker,
            floatingLabelNever: true,
            more: {
                texts: ['Non-expiring', 'Expiring']
            }
        }),
        new SelectControl({
            name: IdentityDocumentStatusSelector,
            value: '',
            placeholder: 'Document status',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true,
            hidden: true
        }),
        new BaseControl({
            name: IdentityDocumentPoISelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            hidden: true
        }),
    ];
};
